import React, { useState, useContext } from 'react';
import { Paper, Container, Button, Stack, TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';

import { simpleMessage } from '../../../../helpers/Helpers';
import { changeSalarioAsync } from '../../../../api/Employees';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';

const ChangeSalario = ({ id, setShowModal, reload, setReload }) => {
	const [salario, setSalario] = useState('');
	const [fechaInicio, setFechaInicio] = useState(new Date());

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const funtionSetSalario = (value) => {
		if (/^\d*\.?\d*$/.test(value.toString()) || value === '') {
			setSalario(value);
			return;
		}
	};

	const saveChanges = async () => {
		if (validate()) {
			const datos = {
				employeeId: id,
				nuevoSalario: salario,
				fechaDesde: moment(fechaInicio).format('YYYY-MM-DD')
			};

			setIsLoading(true);
			const result = await changeSalarioAsync(token, datos);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setReload(!reload);
			setIsLoading(false);
			setShowModal(false);
			simpleMessage('Salario Actualizado...!', 'success');
		}
	};

	const validate = () => {
		let isValid = true;
		if (salario.length === 0) {
			simpleMessage('Debe ingresar un salario', 'error');
			return (isValid = false);
		}

		if (parseFloat(salario) === 0) {
			simpleMessage('Debe ingresar un salario superior a cero', 'error');
			return (isValid = false);
		}

		return isValid;
	};
	return (
		<div>
			<Container style={{ width: 550 }}>
				<Paper
					elevation={10}
					style={{
						padding: 20
					}}
				>
					<Stack spacing={2}>
						<DesktopDatePicker
							closeOnSelect
							label="Fecha Inicio"
							inputFormat="DD/MM/YYYY"
							value={fechaInicio}
							onChange={(newValue) => setFechaInicio(newValue)}
							renderInput={(params) => <TextField fullWidth {...params} />}
						/>

						<TextField
							fullWidth
							onChange={(e) => funtionSetSalario(e.target.value)}
							value={salario}
							label={'Nuevo Salario'}
						/>

						<Button
							variant="outlined"
							startIcon={
								<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
							}
							fullWidth
							onClick={() => saveChanges()}
							style={{
								borderRadius: 25,
								color: '#ffc400',
								borderColor: '#ffc400',
								padding: 13
							}}
							size="large"
						>
							Guardar Nuevo Salario
						</Button>
					</Stack>
				</Paper>
			</Container>
		</div>
	);
};

export default ChangeSalario;
